import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PageHeader from '../shell/PageHeader';
import { RowCard } from '../patterns';
import './AuditLanding.css';

const AuditLanding: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div data-testid="audit-landing">
      <PageHeader title={t('audit.landing.title')} />
      <p data-testid="audit-description" className="audit-landing__description">
        {t('audit.landing.description')}
      </p>

      <section className="audit-landing__reports">
        <h2 className="audit-landing__section-title">
          {t('audit.landing.availableReportsTitle')}
        </h2>
        <ul className="audit-landing__report-list">
          <li>
            <Link to="/audit/application-report" className="audit-landing__report-link">
              <RowCard
                icon="bi-clipboard-check"
                title={t('audit.landing.sprayReport.title')}
                subtitle={t('audit.landing.sprayReport.description')}
              />
            </Link>
          </li>
        </ul>
      </section>
    </div>
  );
};

export default AuditLanding;
